@if (ppIndex === 0) {
  <p class="advancedFilter__logic">{{ 'show' | ppTranslate }}</p>
}

@if (ppIndex === 1) {
  <pp-select
    [ppItems]="logicOptions"
    [ppSelectedItem]="{ value: ppLogic, label: '' }"
    (ppSelectItem)="changeLogic($event)"
    [ppNoSearchBar]="true"
    require
  >
    <ng-container selected>
      @if (selectedOption) {
        <span class="advancedFilter__select-content">
          {{ selectedOption.label }}
        </span>
      } @else {
        <span> {{ logicOptions[0]?.label ?? 'and' }} </span>
      }
    </ng-container>
  </pp-select>
}

@if (ppIndex > 1) {
  <p class="advancedFilter__logic">{{ selectedOption?.label }}</p>
}
